
// state
export const state = {
  showTooltipArrow: true
}

// mutations
export const mutations = {
  /**
   * Set show module arrow
   *
   * @param state
   * @param payload
   * @constructor
   */
  SET_SHOW_TOOLTIP_ARROW (state, payload) {
    state.showTooltipArrow = payload
  },
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/tooltipArrow.js